"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const base_models_1 = require("@integration/base-models");
const identification_service_api_models_1 = require("@integration/identification-service-api-models");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const ProfilePriority_1 = tslib_1.__importDefault(require("./ProfilePriority"));
class GetProfileResponse extends base_models_1.Serializable {
}
tslib_1.__decorate([
    (0, class_validator_1.IsUUID)(),
    (0, class_validator_1.IsDefined)(),
    (0, base_models_1.Docs)({
        example: '5116b17c-77e3-41b3-8565-b49424650387',
        description: 'The ID of the profile.',
    }),
    tslib_1.__metadata("design:type", String)
], GetProfileResponse.prototype, "profileId", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsIn)(Object.values(identification_service_api_models_1.CustomerJourneyPhase)),
    (0, class_validator_1.IsOptional)(),
    (0, base_models_1.Docs)({
        example: identification_service_api_models_1.CustomerJourneyPhase.NEW_CUSTOMER,
        description: 'The customer journey phase of the profile.',
    }),
    tslib_1.__metadata("design:type", String)
], GetProfileResponse.prototype, "customerPhase", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsIn)(Object.values(identification_service_api_models_1.ChurnScore)),
    (0, class_validator_1.IsOptional)(),
    (0, base_models_1.Docs)({
        example: identification_service_api_models_1.ChurnScore.MEDIUM,
        description: 'The churn risk of the profile.',
    }),
    tslib_1.__metadata("design:type", String)
], GetProfileResponse.prototype, "churnRisk", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsIn)(Object.values(identification_service_api_models_1.AcquisitionScore)),
    (0, class_validator_1.IsOptional)(),
    (0, base_models_1.Docs)({
        example: identification_service_api_models_1.AcquisitionScore.MEDIUM,
        description: 'The acquisition score of the profile.',
    }),
    tslib_1.__metadata("design:type", String)
], GetProfileResponse.prototype, "acquisitionScore", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsOptional)(),
    (0, base_models_1.Docs)({
        example: false,
        description: 'True if the customer has an openstanding complaint. Currently stubbed, will not be returned.',
    }),
    tslib_1.__metadata("design:type", Boolean)
], GetProfileResponse.prototype, "complaint", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsOptional)(),
    (0, base_models_1.Docs)({
        example: false,
        description: 'True if the customer is subscribed to a loyalty programme.',
    }),
    tslib_1.__metadata("design:type", Boolean)
], GetProfileResponse.prototype, "loyalty", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => ProfilePriority_1.default),
    tslib_1.__metadata("design:type", Array)
], GetProfileResponse.prototype, "priorities", void 0);
exports.default = GetProfileResponse;
